import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_s3_subjects from './uganda_s3_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_s3 = ( ) => {
 
  return (
    <>
  <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_s3_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s3;
